// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import MyOrders from './MyOrders'
import { actions, constants } from './'
import queryString from 'query-string'

const mapStateToProps = ({ myOrders, router, pointsPurchase: { config: { packageSize } } }) => {
  let products = []
  if (myOrders && myOrders.orders && myOrders.orders.length > 0) {
    myOrders.orders.map((order, index) =>
      order.vendorOrderModel.map((vendor, index) =>
        vendor.items.map((product, index) => {
          var trackingStatusDescription = mapOrderStatus(order.orderStatus)

          products.push({
            imageUrl: product.imageUrl,
            name: product.name,
            quantity: product.quantity,
            sellingPrice: product.sellingPrice,
            deliveryForecast: vendor.deliveryForecast,
            trackingStatusDescription: trackingStatusDescription,
            orderPaymentDetailMoneyAndPoints: order.orderPaymentDetailMoneyAndPoints,
            paymentType: order.paymentType,
            vendorName: vendor.vendorName,
            parentOrderId: order.parentOrderId,
            orderId: vendor.orderId,
            id: product.id,
            costPrice: product.costPrice,
            vendorId: vendor.vendorId,
            vendorType: vendor.vendorType
          })
        })
      )
    )
  }
  const queryStringValues = queryString.parse(router.location.search)
  var result = {
    productOrders: products,
    hasMoreItems: myOrders.hasMoreItems,
    page: myOrders.page,
    ready: myOrders.ready,
    loading: myOrders.loading,
    daysFilter:
      queryStringValues &&
      queryStringValues.days &&
      !isNaN(parseInt(queryStringValues.days))
        ? parseInt(queryStringValues.days)
        : constants.DEFAULTDAYSFILTER,
    currentRoute: router.location.pathname + router.location.search,
    packageSize
  }

  return result
}

const mapOrderStatus = orderStatus => {
  var status
  switch (orderStatus) {
    case 1:
      status = 'Confirmado'
      break
    case 2 :
      status = 'Pendente'
      break
    case 3:
      status = 'Estornado'
      break
    case 4:
      status = 'Pendente'
      break
    case 5 :
      status = 'Confirmado'
      break
    case 6 :
      status = 'Cancelado'
      break
    case 7 :
      status = 'Estornado'
      break
    case 8 :
      status = 'Cancelado'
      break
    case 9 :
      status = 'Pendente'
      break
    case 10 :
      status = 'Cancelado'
      break
    case 11 :
      status = 'Cancelado'
      break
    case 12 :
      status = 'Confirmado'
      break
    case 13 :
      status = 'Cancelado'
      break
    case 14 :
      status = 'Cancelado'
      break
    case 15 :
      status = 'Cancelado'
      break
    case 16 :
      status = 'Cancelado'
      break
    case 17 :
      status = 'Pendente'
      break
    case 18 :
      status = 'Estornado'
      break
    case 19 :
      status = 'Estornado'
      break
  }
  return status
}

const mapDispatchToProps = dispatch => ({
  loadMyOrders: (pageIndex, pageSize, initialDate, endDate) => {
    dispatch(actions.loadMyOrders(pageIndex, pageSize, initialDate, endDate))
  },
  resetMyOrders: () => dispatch(actions.resetMyOrders()),
  setFilterQueryString: days => dispatch(actions.setFilterQueryString(days))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyOrders)



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/MyOrdersContainer.js